// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2Eu6-","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__-GTcJ","gfeWrapper":"CalendarEvent_gfeWrapper__27jHd"};